import MarketRequestsWorkspace from './MarketRequestsWorkspace';

export default MarketRequestsWorkspace;
